import React from 'react';
import { paymentPartners } from '../data/site';
import './sections.css';

/**
 * Payment partner band. Partner names are set as styled wordmarks rather than
 * logo files so no third-party brand assets are bundled with the site.
 */
const PartnerStrip: React.FC = () => (
    <section className="partner-strip">
        <div className="container partner-strip__inner">
            <div className="partner-strip__label" data-reveal="left">
                <span className="kicker">Payment partners</span>
                <p>
                    Payments across every Kifayti platform are collected through our official
                    payment partners, with automated receipts and settlement reporting.
                </p>
            </div>
            <div className="partner-strip__logos">
                {paymentPartners.map((partner, i) => (
                    <div
                        className="partner-chip"
                        key={partner.name}
                        data-reveal="up"
                        style={{ ['--i' as string]: i }}
                    >
                        <span className="partner-chip__name">{partner.name}</span>
                        <span className="partner-chip__note">{partner.note}</span>
                    </div>
                ))}
                <div
                    className="partner-chip partner-chip--muted"
                    data-reveal="up"
                    style={{ ['--i' as string]: paymentPartners.length }}
                >
                    <span className="partner-chip__name">Secure checkout</span>
                    <span className="partner-chip__note">Card data handled by the gateway</span>
                </div>
            </div>
        </div>
    </section>
);

export default PartnerStrip;
